import React from "react";
import { Routes, Route } from "react-router-dom";
import { ParallaxProvider } from "react-scroll-parallax";
import { ParallaxExample, Project } from "../";

const ParallaxRoute = () => (
  <ParallaxProvider>
    <ParallaxExample />
  </ParallaxProvider>
);

const App = () => {
  return (
    <Routes>
      <Route path="/" element={<ParallaxRoute />} />
      <Route path="projects/:projectId" element={<Project />} />
    </Routes>
  );
};

export default App;
